// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue'
import Steps from './components/steps.vue'
import eventBus from './util/eventBus'

/**
 * Vue实例在setHtml方法中声明，初始化执行init的时候就能够创建
 * 声明Vue实例对象时，在其挂载完毕的生命周期里声明一个订阅，用于订阅update方法中发布的消息，从而更新实例数据
 * update方法中，发布一个消息，让Vue实例接收消息，更新数据
 * 在Vue实例的destroyed中，结束订阅
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
(function (KDApi) {
  function MyComponent(model) {
    this._setModel(model)
  }

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      console.log('-----init222', this.model.style, props)
      setHtml(this.model, props)
    },
    update: function (props) {
      console.log('-----update', this.model, props)
      eventBus.pub(this.model, 'update', props)
    },
    destoryed: function () {
      console.log('-----destoryed', this.model)
    }
  }

  const setHtml = (model, props) => {

    KDApi.loadFile('./css/index.css', model, () => {
      const { invoke, dom } = model
      const { data } = props
      const activeI = data ? data.avtiveIndex : -1
      new Vue({
        el: dom,
        template: '<Steps :invoke="invoke" :buildHeadBean="buildHeadBean" :model="model" :isRoomhousetype="isRoomhousetype" :isFloorhousetype="isFloorhousetype" :isUnitholdhousetype="isUnitholdhousetype" :indexList="indexList" :getLangMsg="getLangMsg" :floorBeanList="floorBeanList" :houseTypeSetBeanList="houseTypeSetBeanList" :isSave="isSave"/>',
        components: {
          Steps
        },
        data: {
          activeIndex: activeI,
          model: model,
          buildHeadBean:{},
          floorBeanList:[],
          houseTypeSetBeanList:[],
          isSave:0,
          indexList:[],
          isRoomhousetype:0,
          isFloorhousetype:0,
          isUnitholdhousetype:0,
        },
        mounted() {
          const self = this
          this.updateSub = eventBus.sub(model, 'update', (props) => {
            console.log('props',props)
            const { data } = props
            // self.isSave=0
            // self.isRoomhousetype=0
            // self.isFloorhousetype=0
            // self.isUnitholdhousetype=0
              if(data.type=='guideholdnumber_init_data'){
                  self.floorBeanList = data ? data.buildBean.floorBeanList : []
                  self.houseTypeSetBeanList = data ? data.buildBean.houseTypeSetBeanList : []
                  self.buildHeadBean = data ? data.buildBean.buildHeadBean : {}
                  if( self.buildHeadBean.unitBeanList != undefined ||  self.buildHeadBean.unitBeanList.length > 0){
                      self.buildHeadBean.unitBeanList.forEach((i)=>{
                        if(i.unitHoldBeanList.length==1&&i.name.length>4&&i.name.length<=7)
                        {
                          self.$set(i,'isMore',1)
                        }else if(i.unitHoldBeanList.length==1&&i.name.length>7){
                          self.$set(i,'isMore',2)
                        }else{
                          self.$set(i,'isMore',0)
                        }
                  })
                  }
                  if( self.floorBeanList != undefined ||  self.floorBeanList.length > 0){
                    self.floorBeanList.forEach((item)=>{
                      if( item.unitBeanList != undefined ||  item.unitBeanList.length > 0){
                            item.unitBeanList.forEach((i)=>{
                              // console.log(i.roomBeanList.length,i.name.length)
                              if(i.roomBeanList.length==1&&i.name.length>4&&i.name.length<=7)
                              {
                               
                                self.$set(i,'isMore',1)
                              }else if(i.roomBeanList.length==1&&i.name.length>7){
                                self.$set(i,'isMore',2)
                              }else{
                                self.$set(i,'isMore',0)
                              }
                              i.roomBeanList.forEach((ii)=>{
                                self.$set(ii,'isSelect',false)
                              })

                        })
                      }

                    })
                  }
                  console.log('buildHeadBean1',self.buildHeadBean)
                  console.log('floorBeanList1',self.floorBeanList)
             }
             if(data.type=='guideholdnumber_save_op'){
                console.log('点击下一步后台返回接口')
                self.isSave++
              }
              if(data.type=='guideholdnumber_set_roomhousetypeset'){
                console.log('修改房间1')
                self.isRoomhousetype++
                this.indexList=data.indexList
              //  self.indexList=[0,0,0,0]
              }
              if(data.type=='guideholdnumber_set_floorhousetypeset'){
                console.log('修改楼层1')
                self.isFloorhousetype++
                 this.indexList=data.indexList
              //  self.indexList=[0,0,0,0]
              }
              if(data.type=='guideholdnumber_set_unitholdhousetypeset'){
                console.log('修改单元户型1')
                self.isUnitholdhousetype++
                this.indexList=data.indexList
               // self.indexList=[0,0,0,0]
              }
            //  if()
     
          })
        },
        destroyed() {
          eventBus.unsub(this.updateSub)
        },
        methods: {
          invoke: (eventName, args) => {
            invoke(eventName, args)
          },
          getLangMsg: (key) => {
            return KDApi.getLangMsg(model, key)
          }
        }
      })
    })
  }

  // 注册自定义组件
  KDApi.register('resbdguideholdnumber', MyComponent, {
    isMulLang: true
  })
})(window.KDApi)
